import cls from 'classnames';
import { CoinInfo, CoinDetailJson } from '@/types/common';
import { Image } from '@bfe/moly';
import styles from './index.module.scss';
import { appPath } from '@web3/base-utils';

interface PoolIconsProps {
  iconList: CoinInfo[] | { coinDetailJson: CoinDetailJson }[];
  extraIconUrl: string;
  useSmallIcon?: boolean;
  className?: string;
  poolName?: string;
}

// 主组件 - 根据poolName选择适当的图标组件
export const PoolIcons = (props: PoolIconsProps) => {
  const { poolName, ...restProps } = props;

  // 根据池子类型选择渲染组件
  if (poolName === 'Lombard' || poolName === 'LBTC' || poolName === 'LBTCv') {
    return <LombardPoolIcons {...restProps} />;
  }

  return <DefaultPoolIcons {...restProps} />;
};

// Lombard池专用图标组件
const LombardPoolIcons = ({
  iconList,
  extraIconUrl,
  useSmallIcon,
  className,
}: Omit<PoolIconsProps, 'poolName'>) => {
  if (!iconList || iconList.length === 0) {
    return null;
  }

  const firstIcon = iconList[0];
  const src =
    firstIcon?.coinDetailJson?.iconNightUrl ||
    `${appPath}/svg/home/icon-backup.svg`;

  return (
    <div
      className={cls(styles.container, className, {
        [styles.mainIconBigWrap]: !useSmallIcon,
        [styles.mainIconSmallWrap]: useSmallIcon,
      })}
    >
      <div className={styles.baseCoinRow1}>
        <div className={styles.baseIconWrap}>
          <Image className={styles.baseIcon} alt="" src={src} />
        </div>
      </div>
      <Image
        className={cls(styles.extraIcon, styles.extraIconType1)}
        alt=""
        src={extraIconUrl || `${appPath}/svg/home/icon-backup.svg`}
      />
    </div>
  );
};

// 默认图标组件
const DefaultPoolIcons = ({
  iconList,
  extraIconUrl,
  useSmallIcon,
  className,
}: Omit<PoolIconsProps, 'poolName'>) => {
  const len = iconList.length;
  const useBigIcon = useSmallIcon ? false : len < 5;
  const baseCoinRow1 = iconList.slice(0, len > 4 ? Math.ceil(len / 2) : 2);
  const baseCoinRow2 = iconList.slice(len > 2 ? Math.ceil(len / 2) : len);

  return (
    <div
      className={cls(styles.container, className, {
        [styles.mainIconBigWrap]: useBigIcon,
        [styles.mainIconSmallWrap]: !useBigIcon,
      })}
    >
      {baseCoinRow1.length > 0 && (
        <div className={styles.baseCoinRow1}>
          {baseCoinRow1.map((item) => {
            const src = item?.coinDetailJson?.iconNightUrl;
            return (
              <div className={styles.baseIconWrap} key={src}>
                <Image className={styles.baseIcon} alt="" src={src} />
              </div>
            );
          })}
        </div>
      )}
      {baseCoinRow2.length > 0 && (
        <div className={styles.baseCoinRow2}>
          {baseCoinRow2.map((item, index) => {
            const src = item?.coinDetailJson?.iconNightUrl;
            return (
              <div className={styles.baseIconWrap} key={index}>
                <Image
                  className={styles.baseIcon}
                  alt=""
                  src={src || `${appPath}/svg/home/icon-backup.svg`}
                />
              </div>
            );
          })}
        </div>
      )}
      <Image
        className={cls(styles.extraIcon, {
          [styles.extraIconType1]: len < 3 || len % 2 === 0,
          [styles.extraIconType2]: !(len < 3 || len % 2 === 0),
        })}
        alt=""
        src={extraIconUrl || `${appPath}/svg/home/icon-backup.svg`}
      />
    </div>
  );
};
